import React, { useEffect } from 'react';

const TearmsCondition = () => {
  useEffect(() => {
    document.title = 'Terms of Service | Siri Farms';
  }, []);

  return (
    <div className="bg-white">

      {/* Hero Section */}
      <section className="bg-[#3d5c28] py-16 flex items-center justify-center">
        <div className="text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-3">Terms of Service</h1>
          <p className="text-lg text-gray-200">Last Updated: February 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 px-4 md:px-16 lg:px-24">
        <div className="max-w-4xl mx-auto space-y-10">
          {/* Overview */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Overview</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              This website is operated by Siri Farms. Throughout the site, the terms &ldquo;we,&rdquo; &ldquo;us,&rdquo; and &ldquo;our&rdquo;
              refer to Siri Farms, a Florida-based agricultural business operating out of Okeechobee,
              Florida, United States. Siri Farms offers this website, including all information, tools,
              products, and services available from this site, to you, the user, conditioned upon your
              acceptance of all terms, conditions, policies, and notices stated herein.
            </p>
            <p className="text-gray-600 leading-relaxed mb-3">
              By visiting our website, placing an order, enrolling in a subscription, or otherwise accessing
              or using any part of the Service, you engage in our &ldquo;Service&rdquo; and agree to be bound by these
              Terms of Service (&ldquo;Terms&rdquo;). These Terms apply to all users of the Service, including without
              limitation browsers, customers, subscribers, and contributors of content.
            </p>
            <p className="text-gray-600 leading-relaxed mb-3">
              If you do not agree to all terms and conditions of this agreement, then you may not access
              the website or use any services. Acceptance is expressly limited to these Terms.
            </p>
            <p className="text-gray-600 leading-relaxed">
              We reserve the right to update, modify, or replace any part of these Terms at our sole
              discretion by posting updates to our website. Your continued use of the Service following
              the posting of any changes constitutes acceptance of those changes.
            </p>
          </div>

          {/* Section 1 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 1 – Eligibility and Online Store Terms</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              By using this Service, you represent that you are at least 18 years of age and the age of
              majority in your jurisdiction of residence.
            </p>
            <p className="text-gray-600 leading-relaxed mb-3">
              You may not use our products or services for any illegal or unauthorized purpose, nor may
              you violate any applicable federal, state, or local laws, including agricultural, food safety, or
              consumer protection laws.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Any breach of these Terms may result in immediate termination of your access to the
              Service.
            </p>
          </div>

          {/* Section 2 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 2 – General Conditions</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              We reserve the right to refuse service to anyone for any reason at any time, to the fullest
              extent permitted by law.
            </p>
            <p className="text-gray-600 leading-relaxed mb-3">
              You understand that content you submit, excluding payment information, may be
              transferred over various networks and adapted to technical requirements. Payment
              information is handled through secure, encrypted systems.
            </p>
            <p className="text-gray-600 leading-relaxed">
              You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Service
              without express written permission from Siri Farms.
            </p>
          </div>

          {/* Section 3 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 3 – Product Information and Agricultural Disclosures</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              Siri Farms sells fresh fruits, fruit boxes, fruit trees, and subscription-based agricultural
              products. All products are subject to availability, seasonality, weather conditions, and
              agricultural variability.
            </p>
            <p className="text-gray-600 leading-relaxed mb-3">
              You acknowledge that fresh agricultural products may vary in size, color, ripeness, and
              appearance due to natural growing conditions. Such variations do not constitute defects.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Fruit trees are living agricultural products. We make no guarantees regarding long-term
              growth, yield, or survival after delivery, as these depend on climate, care, soil, and other
              factors beyond our control.
            </p>
          </div>

          {/* Section 4 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 4 – Accuracy, Completeness, and Timeliness of Information</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              We are not responsible if information on this site is inaccurate, incomplete, or not current.
              All content is provided for general informational purposes only.
            </p>
            <p className="text-gray-600 leading-relaxed">
              We reserve the right to modify content at any time without obligation to update prior
              information.
            </p>
          </div>

          {/* Section 5 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 5 – Pricing and Modifications to Service</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              All prices are subject to change without notice.
            </p>
            <p className="text-gray-600 leading-relaxed">
              We reserve the right to modify or discontinue the Service, or any product offering, at any
              time without liability.
            </p>
          </div>

          {/* Section 6 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 6 – Orders, Cancellations, and Subscriptions</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              We reserve the right to refuse or cancel any order at our discretion.
            </p>
            <p className="text-gray-600 leading-relaxed mb-3">
              Customers may cancel orders prior to shipment without a cancellation fee.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Subscription services automatically renew according to the selected delivery schedule
              unless canceled by the customer before the next billing cycle.
            </p>
          </div>

          {/* Section 7 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 7 – Shipping, Delivery, and Pickup</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              We offer nationwide shipping within the United States and local pickup options.
            </p>
            <p className="text-gray-600 leading-relaxed mb-3">
              Delivery times are estimates and may be affected by weather conditions, carrier delays,
              agricultural harvesting schedules, or other factors beyond our control.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Risk of loss passes to the customer upon delivery or pickup.
            </p>
          </div>

          {/* Section 8 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 8 – Returns, Refunds, and Replacements</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              Due to the perishable nature of our products, we do not offer returns.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Refunds or replacements may be issued at our sole discretion for products that arrive
              damaged, spoiled, or materially defective. Claims must be submitted within a reasonable
              time after delivery with photographic evidence.
            </p>
          </div>

          {/* Section 9 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 9 – Substitutions</h2>
            <p className="text-gray-600 leading-relaxed">
              If a product becomes unavailable or fails to meet our quality standards, we reserve the
              right to substitute it with an item of equal or greater value.
            </p>
          </div>

          {/* Section 10 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 10 – Third-Party Services and Platforms</h2>
            <p className="text-gray-600 leading-relaxed">
              Certain aspects of the Service may rely on third-party providers, including payment
              processors, shipping carriers, SMS platforms, and social media services. We are not
              responsible for the actions or omissions of such third parties.
            </p>
          </div>

          {/* Section 11 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 11 – SMS Communications</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              By opting in to SMS notifications, you consent to receive transactional and promotional
              messages. Message frequency may vary. Message and data rates may apply.
            </p>
            <p className="text-gray-600 leading-relaxed">
              You may opt out at any time by following the instructions provided in the message.
            </p>
          </div>

          {/* Section 12 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 12 – User Content and Feedback</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              Any feedback, reviews, or submissions provided to Siri Farms may be used by us without
              restriction or compensation.
            </p>
            <p className="text-gray-600 leading-relaxed">
              You represent that you have the rights to any content you submit and that it does not violate
              any third-party rights.
            </p>
          </div>

          {/* Section 13 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 13 – Prohibited Uses</h2>
            <p className="text-gray-600 leading-relaxed">
              You are prohibited from using the Service for unlawful purposes, transmitting malicious
              code, violating intellectual property rights, misrepresenting information, or interfering with
              the security or functionality of the Service.
            </p>
          </div>

          {/* Section 14 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 14 – Disclaimer of Warranties</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              All products and services are provided &ldquo;as is&rdquo; and &ldquo;as available,&rdquo; to the fullest extent
              permitted by law.
            </p>
            <p className="text-gray-600 leading-relaxed">
              We disclaim all warranties, express or implied, including implied warranties of
              merchantability and fitness for a particular purpose, except where prohibited under
              applicable agricultural or consumer protection laws.
            </p>
          </div>

          {/* Section 15 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 15 – Limitation of Liability</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              To the fullest extent permitted by law, Siri Farms shall not be liable for any indirect,
              incidental, special, or consequential damages arising from your use of the Service or
              products.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Our total liability shall not exceed the amount paid for the applicable product.
            </p>
          </div>

          {/* Section 16 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 16 – Indemnification</h2>
            <p className="text-gray-600 leading-relaxed">
              You agree to indemnify and hold harmless Siri Farms, its owners, employees, and agents
              from any claims arising out of your breach of these Terms or misuse of the Service.
            </p>
          </div>

          {/* Section 17 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 17 – Termination</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              We may terminate or suspend your access to the Service at any time for violations of these
              Terms.
            </p>
            <p className="text-gray-600 leading-relaxed">
              All obligations incurred prior to termination shall survive termination.
            </p>
          </div>

          {/* Section 18 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 18 – Governing Law</h2>
            <p className="text-gray-600 leading-relaxed">
              These Terms shall be governed by and construed in accordance with the laws of the State
              of Florida, United States, without regard to conflict of law principles.
            </p>
          </div>

          {/* Section 19 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 19 – Severability</h2>
            <p className="text-gray-600 leading-relaxed">
              If any provision of these Terms is found to be unenforceable, the remaining provisions shall
              remain in full force and effect.
            </p>
          </div>

          {/* Section 20 */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 20 – Entire Agreement</h2>
            <p className="text-gray-600 leading-relaxed">
              These Terms constitute the entire agreement between you and Siri Farms and supersede
              any prior agreements or understandings.
            </p>
          </div>

          {/* Section 21 – Contact */}
          <div className="border-t border-gray-200 pt-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Section 21 – Contact Information</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Questions about these Terms of Service should be directed to:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
              <p className="font-bold text-gray-800 text-lg">Siri Farms</p>
              <p className="text-gray-600">1800 NW 160th St</p>
              <p className="text-gray-600">Okeechobee, FL 34972</p>
              <p className="text-gray-600 mt-2">
                Email: <a href="mailto:sirifarmsfreshproduce@gmail.com" className="text-[#3d5c28] font-medium hover:underline">sirifarmsfreshproduce@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TearmsCondition;